export default "__VITE_ASSET__c669d28b__"